'use strict';

customerZone

/**
 * A wrapper around localStorage that can fall back to cookies if localStorage borks up.
 **/
.service('Storage', ['$log', function ($log) {
    var self = this;

    var storage;

    var LS_STORAGE = nativeLocalStorage();
    var COOKIE_STORAGE = (function(){

        var setCookie = function(name, value, days) {
            var date = new Date();
            date.setTime(date.getTime()+(days*24*60*60*1000));
            var expires = '; secure=true; expires='+date.toGMTString();
            document.cookie = name+'='+value+expires;
        };

        var readCookie =function (name) {
            var cookies = {};
            document.cookie.split(';').forEach(function(cookieString){
                var parts = cookieString.split('=');
                if (parts.length > 1)
                    cookies[parts[0].trim()] = parts[1].trim();
            });
            return cookies[name];
        };

        var updateData = function() {
            var payload = encodeURIComponent(JSON.stringify(data));
            setCookie('localStorage', payload, 365);
        };

        var decodeCookie = function() {
            var payload = readCookie('localStorage');
            return payload ? JSON.parse(decodeURIComponent(payload)) : {};
        };

        // Initialise if there's already data.
        var data = decodeCookie();

        return {
            length: 0,
            clear: function () {
                data = {};
                this.length = 0;
                updateData();
            },
            getItem: function (key) {
                return data[key] === undefined ? null : data[key];
            },
            key: function (i) {
                return Object.keys(data)[i];
            },
            removeItem: function (key) {
                delete data[key];
                this.length--;
                updateData();
            },
            setItem: function (key, value) {
                data[key] = value+'';
                this.length++;
                updateData();
            },
            getCookie: function (key) {
                var nameEQ = key + '=';
                var ca = document.cookie.split(';');
                for (var i= 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) ===' ') c = c.substring(1, c.length);
                    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
                }
                return null;
            }
        };
    }());

    var init = function(){
        storage = localStorageAvailable() ? LS_STORAGE : COOKIE_STORAGE;
    };

    self.setItem = function(key, value){
        return storage.setItem(key, value);
    };

    self.setObject = function(key, object){
        return storage.setItem(key, object ? JSON.stringify(object) : '');
    };

    self.getItem = function(key){
        return storage.getItem(key);
    };

    self.getCookie = function (key) {
        var cookie = COOKIE_STORAGE.getCookie(key);
        return decodeURIComponent(cookie);
    };

    self.getObject = function(key){
        var value = storage.getItem(key);
        if (!value || '' === value) return undefined;
        return JSON.parse(value);
    };

    self.removeItem = function(key){
        return storage.removeItem(key);
    };

    function nativeLocalStorage(){
        try {
            return window.localStorage;
        }
        catch (e) {
            // on both mobile chrome and safari, merely reading the variable will throw an exception.
            // See https://www.chromium.org/for-testers/bug-reporting-guidelines/uncaught-securityerror-failed-to-
            // read-the-localstorage-property-from-window-access-is-denied-for-this-document
            return {};
        }
    }

    var localStorageAvailable = function(){
        try {
            // Test webstorage existence.
            if (!window.localStorage || !window.sessionStorage) throw 'no storage available';
            // Test webstorage accessibility - Needed for Safari private browsing.
            window.localStorage.setItem('storage_test', 1);
            window.localStorage.removeItem('storage_test');
            return true;
        }
        catch (e){
            $log.debug('No localstorage available');
            return false;
        }
    };

    init();

}]);
